import { FilePdfOutlined, FileOutlined, FileExcelOutlined } from '@ant-design/icons';
import CsvIconOutlined from 'components/icons/CsvIconOutlined';

type Props = {
    type?: 'pdf' | 'xlsx' | 'xls' | 'default' | any;
    style?: React.CSSProperties;
};

const FileIcon = ({ type = 'default', style }: Props) => {
    const defaultStyles: React.CSSProperties = {
        fontSize: 24,
        color: 'var(--gray-9)',
    };

    const iconStyle = style ?? defaultStyles;

    switch (type) {
        case 'application/pdf':
        case 'pdf': {
            return <FilePdfOutlined style={iconStyle} />;
        }

        case 'xls':
        case 'xlsx': {
            return <FileExcelOutlined style={iconStyle} />;
        }

        case 'csv': {
            return <CsvIconOutlined style={iconStyle} />;
        }

        default:
            return <FileOutlined style={iconStyle} />;
    }
};

export default FileIcon;
